import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CommonLayoutModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { TruckOverviewFilterComponent } from './component/truck-overview-filter.component';

@NgModule({
  declarations: [
    TruckOverviewFilterComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonLayoutModule,
    CommonTranslationModule
  ],
  exports: [
    TruckOverviewFilterComponent
  ]
})
export class TruckOverviewFilterModule { }
